import { ReactComponent as VideoOn } from './camera-on.svg';
import { ReactComponent as HamburgerHorizontal } from './hamburger-horizontal.svg';
import { ReactComponent as CancelClose } from './cancel-close.svg';
import { ReactComponent as IbisVisionLogo } from './ibisvision-logo.svg';
import { ReactComponent as RebrandLogo } from '../../../assets/img/rebrand-logo.svg';
import { ReactComponent as EmailEnvelope } from './email-envelope.svg';
import { ReactComponent as PasswordLock } from './password-lock.svg';
import { ReactComponent as MenuClose } from './menu-close.svg';
import { ReactComponent as ArrowDown } from './arrow-down.svg';
import { ReactComponent as ArrowUp } from './arrow-up.svg';
import { ReactComponent as CreditCard } from './credit-card.svg';
import { ReactComponent as RotatePhone } from './rotate-phone.svg';
import { ReactComponent as Ruler } from './ruler.svg';
import { ReactComponent as BlindSpotVideoSlider } from './blindspot-video-slider.svg';
import { ReactComponent as Repeat } from './repeat.svg';
import { ReactComponent as VideoOff } from './video-off.svg';
import { ReactComponent as PointingArrowRight } from './pointing-arrow-right.svg';
import { ReactComponent as TrashcanDelete } from './trashcan-delete.svg';
import { ReactComponent as LoadingSpinner } from './loading-spinner.svg';
import { ReactComponent as PersonProfile } from './person-profile.svg';
import { ReactComponent as NotesClipboard } from './notes-clipboard.svg';
import { theme } from '../design-system';

export const videoOn = (fill = theme.colors.primary) => <VideoOn fill={fill} />;
export const videoOff = (fill = theme.colors.primary) => <VideoOff fill={fill} />;
export const hamburgerHorizontal = (fill = theme.colors.primary) => <HamburgerHorizontal fill={fill} />;
export const cancelClose = (fill = theme.colors.primary) => <CancelClose fill={fill} />;
export const ibisVisionLogo = (fill = theme.colors.primary) => <IbisVisionLogo fill={fill} />;
export const rebrandedIbisVisionLogo = (fill = theme.colors.primary) => <RebrandLogo fill={fill} />;
export const emailEnvelope = (fill = theme.colors.primary) => <EmailEnvelope fill={fill} />;
export const passwordLock = (fill = theme.colors.primary) => <PasswordLock fill={fill} />;
export const menuClose = (fill = theme.colors.primary) => <MenuClose fill={fill} />;
export const arrowDown = (fill = 'black') => <ArrowDown fill={fill} />;
export const arrowUp = (fill = 'black') => <ArrowUp fill={fill} />;
export const creditCard = (fill = theme.colors.secondary) => <CreditCard fill={fill} />;
export const rotatePhone = (fill = 'black') => <RotatePhone fill={fill} />;
export const ruler = (fill = theme.colors.primary) => <Ruler fill={fill} stroke={fill} />;
export const repeat = (fill = theme.colors.primary) => <Repeat fill={fill} />;
export const blindSpotVideoSlider = (fill = theme.colors.neutralDark) => <BlindSpotVideoSlider fill={fill} />;
export const pointingArrowRight = (fill = theme.colors.primary) => <PointingArrowRight fill={fill} />;
export const trashcanDelete = (fill = theme.colors.negativeDark) => <TrashcanDelete fill={fill} />;
export const personProfile = (fill = theme.colors.primary) => <PersonProfile fill={fill} />;
export const notesClipboard = (fill = theme.colors.primary) => <NotesClipboard fill={fill} />;
export const loadingSpinner = () => <LoadingSpinner />;
